/**
 * Product Overview 侧滑弹窗：绑定 data-overview-modal-target 与 .product-overview-modal
 * 根容器可为 .product-reference-info、.product-concept、.product-more-details（可多实例）
 */
function bootProductOverviewModals() {
  if (window.__productOverviewModalsBooted) {
    return;
  }
  window.__productOverviewModalsBooted = true;

  const collectRoots = function () {
    const roots = [];
    const productReferenceInfo = document.querySelector('.product-reference-info');
    if (productReferenceInfo) {
      roots.push(productReferenceInfo);
    }
    document.querySelectorAll('.product-concept').forEach(function (sectionRoot) {
      roots.push(sectionRoot);
    });
    document.querySelectorAll('.product-more-details').forEach(function (sectionRoot) {
      roots.push(sectionRoot);
    });
    return roots;
  };

  const closeOverviewModal = function (modal) {
    if (!modal) {
      return;
    }
    modal.classList.remove('is-active');
    window.setTimeout(function () {
      if (!modal.classList.contains('is-active')) {
        modal.classList.remove('is-visible');
        modal.setAttribute('aria-hidden', 'true');
      }
      if (!document.querySelector('.product-overview-modal.is-visible')) {
        document.body.style.overflow = '';
      }
    }, 320);
  };

  const openOverviewModal = function (modal) {
    if (!modal) {
      return;
    }
    document.querySelectorAll('.product-overview-modal').forEach(function (item) {
      item.classList.remove('is-active');
      item.classList.remove('is-visible');
      item.setAttribute('aria-hidden', 'true');
    });
    modal.classList.add('is-visible');
    window.requestAnimationFrame(function () {
      modal.classList.add('is-active');
    });
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };

  const roots = collectRoots();
  let anyModal = false;

  roots.forEach(function (root) {
    const overviewModals = Array.from(root.querySelectorAll('.product-overview-modal'));
    if (!overviewModals.length) {
      return;
    }
    anyModal = true;

    overviewModals.forEach(function (modal) {
      document.body.appendChild(modal);
    });

    root.querySelectorAll('[data-overview-modal-target]').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        const target = trigger.getAttribute('data-overview-modal-target');
        if (!target) {
          return;
        }
        const targetModal = document.querySelector(
          '.product-overview-modal[data-overview-modal="' + target + '"]'
        );
        if (!targetModal) {
          return;
        }
        openOverviewModal(targetModal);
      });
    });

    overviewModals.forEach(function (modal) {
      modal.querySelectorAll('[data-overview-modal-close]').forEach(function (closeBtn) {
        closeBtn.addEventListener('click', function () {
          closeOverviewModal(modal);
        });
      });
    });
  });

  if (anyModal) {
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') {
        return;
      }
      const activeModal = document.querySelector('.product-overview-modal.is-active');
      if (activeModal) {
        closeOverviewModal(activeModal);
      }
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootProductOverviewModals);
} else {
  bootProductOverviewModals();
}
